
import { useTranslation } from 'react-i18next';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
  twitterCard?: 'summary' | 'summary_large_image';
}

const SEO = ({ 
  title, 
  description, 
  image = '/og-image.png',
  url,
  type = 'website',
  twitterCard = 'summary_large_image'
}: SEOProps) => {
  const { t } = useTranslation();
  
  const siteTitle = 'Claroclaim';
  const metaTitle = title ? `${title} | ${siteTitle}` : siteTitle;
  const metaDescription = description || t('common.metaDescription', 'Claroclaim');
  const siteUrl = window.location.origin;
  const canonicalUrl = url ? `${siteUrl}${url}` : window.location.href;
  const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <>
      {/* Standard metadata */}
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={imageUrl} />
    </>
  );
};

export default SEO;
